import PropTypes from "prop-types";
import {
  Alert,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  List,
  ListItem,
  Snackbar,
  Stack,
} from "@mui/material";

import Swal from "sweetalert2";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import { useEffect, useState, useRef } from "react";
import OponentsView from "./components/oponents-view";
import MarketGroupsView from "./components/market-groups-view";
import MarketView from "./components/market-view";
// react-router-dom components
import { useLocation, useSearchParams } from "react-router-dom";
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import { useSoftUIController } from "context";

import { getUserData, getAuthorizationHeader } from "Utils/helpers";
import { getData, postData } from "Utils/server";
import SoftTypography from "components/SoftTypography";
import SoftProgress from "components/SoftProgress";

import LinearProgress, { linearProgressClasses } from "@mui/material/LinearProgress";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#1a90ff" : "#308fe8",
  },
}));

var cachedEvent = null;
var cachedMarketGroups = null;
var cachedProviders = null;
var cachedMarketGroupSelected = null;
var cachedPlatform = null;

let waitForSwal = null;
let oddsUuids = [];
let stackItems = [];
let proccessedOdds = [];

function FixtureView() {
  const abortController = new AbortController();

  const Ref = useRef(null);
  const fixtureCardRef = useRef(null);
  const HIGHER_ROLE = 49;

  const location = useLocation();
  let [searchParams, setSearchParams] = useSearchParams();
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();
  const { marketGroups, providers } = controller;
  const [event, setEvent] = useState(null);
  const [marketGroupsFiltered, setMarketGroupsFiltered] = useState(null);
  const [blockedChanges, setBlockedChanges] = useState(false);
  const [markets, setMarkets] = useState(null);
  const [fixtureCardHeight, setFixtureCardHeight] = useState(null);
  const [extraColumnView, setExtraColumnView] = useState(false);
  const [scoreboardView, setScoreboardView] = useState(false);
  const [vlCourtView, setVlCourtView] = useState(false);
  const [timelineView, setTimelineView] = useState(false);
  const [liveStatsView, setLiveStatsView] = useState(false);
  const [forceClose, setForceClose] = useState(false);
  const [massClose, setMassClose] = useState(null);
  const [openBackDrop, setOpenBackDrop] = useState(true);
  const [marketGroupSelected, setMarketGroupSelected] = useState(null);
  const [notAvailable, setNotAvailable] = useState(true);
  const [notMarketsAvailable, setNotMarketsAvailable] = useState(false);
  const [fetch, fetching] = useState(false);

  const [notification, setNotification] = useState(true);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [swalBettingCounter, setSwalBettingCounter] = useState("Wait until bets completed...");
  const [showBetsReport, setShowBetsReport] = useState(false);
  const [oddsStyleChange, setOddsStyleChange] = useState();
  const [releaseOperBlocked, setReleaseOperBlocked] = useState(false);
  const [blockedEntities, setBlockedEntities] = useState([]);

  // The state for our timer
  const [timer, setTimer] = useState("00:00:00");
  let roles = userData.roles.sort((a, b) => (a.id > b.id ? 1 : -1));
  let higherRole = roles[0].id;
  const params = [...searchParams.entries()];

  let refreshCycleSecs = higherRole < HIGHER_ROLE ? 2 : 3;

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  async function getParticipantsLogos(event) {
    if (cachedEvent) {
      event.fixtureInfo.participants[0].logo = cachedEvent.fixtureInfo.participants[0].logo;
      event.fixtureInfo.participants[1].logo = cachedEvent.fixtureInfo.participants[1].logo;
      return;
    }

    let getOddsEndpoint = `/api/v1/entities/participantsLogos`;

    let ids = [];
    if (event.fixtureInfo.participants[0].id) ids.push(event.fixtureInfo.participants[0].id);
    if (event.fixtureInfo.participants[1].id) ids.push(event.fixtureInfo.participants[1].id);

    if (ids.length == 0) return;

    let response = await postData(
      getOddsEndpoint,
      { participants: ids },
      {
        Authorization: getAuthorizationHeader(),
      }
    );

    if (response != null) {
      let home = event.fixtureInfo.participants[0].id
        ? response.data.find((item) => item.id == event.fixtureInfo.participants[0].id)
        : null;
      let away = event.fixtureInfo.participants[1].id
        ? response.data.find((item) => item.id == event.fixtureInfo.participants[1].id)
        : null;

      event.fixtureInfo.participants[0].logo = home ? home.logo : null;
      event.fixtureInfo.participants[1].logo = away ? away.logo : null;
    }
  }

  async function initData(fixture_to_init) {
    if (!fixture_to_init) return;
    if (cachedEvent && cachedEvent.fixtureInfo.lastUpdate == fixture_to_init.fixtureInfo.lastUpdate)
      return;
    await sleep(500);

    let event = fixture_to_init;
    // console.log("fixture: ", event);

    await getParticipantsLogos(event);

    let marketsGroupsAvailable = [];
    for (let index = 0; index < event.markets.length; index++) {
      const market = event.markets[index];
      for (let index2 = 0; index2 < market.properties.groups.length; index2++) {
        const group = market.properties.groups[index2];
        if (marketsGroupsAvailable.indexOf(group) > -1) continue;
        marketsGroupsAvailable.push(group);
      }
    }

    let market_groups = cachedMarketGroups
      ? cachedMarketGroups.filter(
          (item) =>
            item.sport_id == fixture_to_init.sport && marketsGroupsAvailable.indexOf(item.id) > -1
        )
      : [];

    market_groups = market_groups.sort((a, b) => a.sort - b.sort);

    if (
      (cachedMarketGroupSelected > 0 ||
        cachedMarketGroupSelected == -1 ||
        cachedMarketGroupSelected == null) &&
      !market_groups.find((mg) => mg.id == cachedMarketGroupSelected)
    ) {
      cachedMarketGroupSelected = 999999;
    }
    // console.log("cachedMarketGroupSelected: ", cachedMarketGroupSelected);
    let market_sorted = event.markets.sort((a, b) => a.properties.sort - b.properties.sort);

    setNotMarketsAvailable(market_sorted.length == 0);

    cachedEvent = fixture_to_init;
    setEvent(event);
    setMarketGroupsFiltered(market_groups);
    await sleep(100);

    if (cachedMarketGroupSelected)
      marketGroupChange(new Event("marketGroupChange_Custom"), cachedMarketGroupSelected);
    if (fixture_to_init) setNotAvailable(false);
    setOpenBackDrop(false);
  }

  function marketsFiltering(marketGroup) {
    let marketsFiltered = JSON.parse(JSON.stringify(cachedEvent.markets));
    if (marketGroup != null) {
      marketsFiltered = marketsFiltered.filter((market) => {
        return market.properties.groups.indexOf(marketGroup) > -1;
      });
    }

    setMarkets(marketsFiltered);
  }

  function marketsOperatorFiltering(filterOption) {
    let marketsFiltered = JSON.parse(JSON.stringify(cachedEvent.markets));
    if (filterOption == -2) {
      marketsFiltered = marketsFiltered.filter((item) => {
        return item.status == "suspended";
      });
    }

    if (filterOption == -3) {
      marketsFiltered = marketsFiltered.filter((item) => {
        return item.name == null;
      });
    }

    if (filterOption == -4) {
      marketsFiltered = marketsFiltered.filter((item) => {
        let probOdds = item.odds.find(
          (odd) => odd.name == null || item.properties.uni_name == odd.name
        );
        return probOdds ? true : false;
      });
    }

    setMarkets(marketsFiltered);
  }

  async function marketGroupChange(e, marketGroup) {
    e.preventDefault();
    // console.log("marketGroup Pressed: ", marketGroup);
    cachedMarketGroupSelected =
      marketGroup != "betAll" &&
      marketGroup != "betsReport" &&
      marketGroup != "oddsStyle" &&
      marketGroup != "saveBlocked"
        ? marketGroup
        : cachedMarketGroupSelected;
    switch (marketGroup) {
      case -1:
        forceClose ? setForceClose(true) : setForceClose(false);
        if (massClose != null) {
          setMassClose(!massClose);
        } else {
          setMassClose(true);
        }
        break;
      case -2:
        marketsOperatorFiltering(marketGroup);
        break;
      case -3:
        marketsOperatorFiltering(marketGroup);
        break;
      case -4:
        marketsOperatorFiltering(marketGroup);
        break;
      case 999999:
        marketsFiltering(null);
        break;
      case "betAll":
        betAllOdds();
        break;
      case "betsReport":
        showLastBets();
        break;
      case "oddsStyle":
        if (!e.currentTarget) return;
        const selectedOddsStyles = e.currentTarget.value;
        setOddsStyleChange(selectedOddsStyles);
        break;
      case "saveBlocked":
        if (!e.currentTarget) return;
        handleMarketsBlockedConfirmation(e);
        break;
      default:
        marketsFiltering(marketGroup);
        break;
    }
    await sleep(1000);
    //setOpenBackDrop(false);
  }

  async function blockedChange(e, signal) {
    e.preventDefault();
    let blockedEntitiesTmp = [...blockedEntities];
    const operBlockedMarkets = blockedEntitiesTmp ? blockedEntitiesTmp : [];
    let marketIndex = -1;
    switch (signal.type) {
      case "marketChange":
        marketIndex = operBlockedMarkets.findIndex((bm) => bm.uuid == signal.data.uuid);
        if (marketIndex == -1) {
          operBlockedMarkets.push(signal.data);
        } else {
          operBlockedMarkets[marketIndex] = signal.data;
        }
        blockedEntitiesTmp = operBlockedMarkets;
        setBlockedEntities(blockedEntitiesTmp);
        setBlockedChanges(true);
        break;
      case "releaseCompleted":
        setReleaseOperBlocked(false);
        break;
      default:
        break;
    }
  }

  async function fetchFixtureData() {
    let platformId = cachedPlatform ? cachedPlatform : userData.defaultPlatform.value;
    let providerId = null;
    let competitionId = null;
    let id = null;
    let type = null;
    let sport = null;

    for (let index = 0; index < params.length; index++) {
      const param = params[index];
      if (param[0] == "platformId") platformId = param[1];
      if (param[0] == "providerId") providerId = param[1];
      if (param[0] == "competitionId") competitionId = param[1];
      if (param[0] == "id") id = param[1];
      if (param[0] == "type") type = param[1];
      if (param[0] == "sport") sport = param[1];
    }

    let getOddsEndpoint = `/api/v1/keys/${platformId}/fixtures/${type}/${sport}`;
    getOddsEndpoint = `${getOddsEndpoint}/${competitionId}/${providerId}/${id}`;

    let providerName =
      cachedProviders && cachedProviders.find((p) => p.value == providerId)
        ? cachedProviders.find((p) => p.value == providerId)["label"]
        : "";
    let response = await getData(getOddsEndpoint, {
      Authorization: getAuthorizationHeader(),
    });

    if (response != null) {
      let fixture_api = response.data;
      if (response.data) {
        let dt = new Date(fixture_api.fixture.startDate).toLocaleString("en-GB");
        let matchResultMarket = null;
        fixture_api = createFixtureData(
          fixture_api.fixture.eventId,
          providerId,
          providerName,
          fixture_api.fixture.sport.id,
          fixture_api.fixture.region.providerName,
          fixture_api.fixture.competition.providerName,
          fixture_api.type,
          dt,
          fixture_api.fixture.participants[0].providerName,
          fixture_api.fixture.participants[1].providerName,
          fixture_api.fixture.status,
          fixture_api.filtered,
          matchResultMarket
            ? {
                name: matchResultMarket.name,
                odds: matchResultMarket.odds,
              }
            : { name: "", odds: null },
          fixture_api.markets.filter((item) => item.status !== "deleted"),
          [{ vlcourt: false }, { stats: true }, { timeline: true }, { scoreboard: true }],
          fixture_api.live,
          fixture_api.fixture,
          fixture_api.oddsBlocked
        );

        //console.log("fixture to init: ", fixture_api);
        initData(fixture_api);
      } else {
        setNotAvailable(true);
      }
    } else {
      setNotAvailable(true);
    }
    await sleep(100);
    fetching(false);
  }

  function createFixtureData(
    fixtureId: number,
    provider_id: number,
    providerName: string,
    sport: string,
    region: string,
    league: string,
    type: string,
    date: string,
    home: string,
    away: string,
    status: string,
    filtered: boolean,
    matchresult: object,
    markets: array,
    products: array,
    live: object,
    fixtureInfo: object,
    blockedOdds: array
  ) {
    return {
      fixtureId,
      provider_id,
      providerName,
      sport,
      region,
      league,
      type,
      date,
      home,
      away,
      status,
      filtered,
      matchresult,
      markets,
      products,
      live,
      fixtureInfo,
      blockedOdds,
    };
  }

  const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 / 60 / 60) % 24);
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } = getTimeRemaining(e);
    if (total >= 0) {
      // update the timer
      // check if less than 10 then we need to
      // add '0' at the beginning of the variable
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
          ":" +
          (minutes > 9 ? minutes : "0" + minutes) +
          ":" +
          (seconds > 9 ? seconds : "0" + seconds)
      );
    }
    if (total < 0) clearTimer(getDeadTime());
  };

  const clearTimer = (e) => {
    // If you adjust it you should also need to
    // adjust the Endtime formula we are about
    // to code next
    fetching(true);
    setTimer("00:00:" + refreshCycleSecs);

    // If you try to remove this line the
    // updating of timer Variable will be
    // after 1000ms or 1sec
    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;

    fetchFixtureData();
  };

  const getDeadTime = () => {
    let deadline = new Date();

    // This is where you need to adjust if
    // you entend to add more time
    deadline.setSeconds(deadline.getSeconds() + refreshCycleSecs);
    return deadline;
  };

  const openPreStats = (e, statsId) => {
    e.preventDefault();

    let protocol = window.location.protocol;
    let hostname = window.location.hostname;
    let port = window.location.hostname == "localhost" ? "3000" : "5030";
    let route = "/stats";
    let params = `?apikey=1f5abd3dfef60f2611e30b946f7f1be7&statsid=${statsId}`;
    let url = `${process.env.REACT_APP_PREGAMESTATS_URL}${route}${params};`;
    window.open(
      url.toString(),
      "_blank",
      "toolbar=no, location=no, directories=no, status=no, menubar=no, width=780,noreferrer"
    );
  };

  const oponentsHandleClick = (e, item) => {
    e.preventDefault();
    //console.log(item);

    if (!cachedEvent && !cachedEvent.live) return;

    switch (item) {
      case "scoreboard":
        if (!cachedEvent.live.scoreBoard) return;
        setScoreboardView(!scoreboardView);
        break;
      case "timeline":
        if (!cachedEvent.live.timeline || !cachedEvent.live.timeline.length > 0) return;
        if (!cachedEvent.live.timeline.filter((te) => te.participant).length > 0) return;
        setTimelineView(!timelineView);
        break;
      case "vlcourt":
        if (
          !cachedEvent.fixtureInfo.virtualCourtId ||
          cachedEvent.fixtureInfo.status != "In progress"
        )
          return;
        setVlCourtView(!vlCourtView);
        break;
      case "liveStats":
        if (!cachedEvent.live.scoreBoard) return;
        setLiveStatsView(!liveStatsView);
        break;
      case "stats":
        if (!cachedEvent.fixtureInfo.statsId) return;
        openPreStats(new Event("openStats"), cachedEvent.fixtureInfo.statsId);
        break;
      default:
        break;
    }
  };

  const clearSwal = () => {
    waitForSwal.close();
    waitForSwal = null;
    stackItems = [];
  };

  async function betAllOdds() {
    oddsUuids = [];
    proccessedOdds = [];

    for (let index = 0; index < cachedEvent.markets.length; index++) {
      const market = cachedEvent.markets[index];
      for (let index2 = 0; index2 < market.odds.length; index2++) {
        const odd = market.odds[index2];
        oddsUuids.push(odd.properties.uuid);
      }
    }

    setSwalBettingCounter(`Wait until ${oddsUuids.length} bets will be placed...`);

    Swal.fire({
      title: `Ready to Bet`,
      html: `You are going to place bets for ${oddsUuids.length} Odds.
              </br></br>
              Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Place them!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        handleAutoPlaceBetsFunctionality();
        for (let index = 0; index < oddsUuids.length; index++) {
          const uuid = oddsUuids[index];
          let response = await placeBet(uuid);
          if (response) {
            Swal.getTitle().textContent = `Wait until ${oddsUuids.length} bets will be placed...`;
            Swal.getHtmlContainer().textContent = `${index + 1}/${oddsUuids.length} Bet Processed`;
            Swal.hideLoading();
            setApiresponse("success");
            setApiResponseMsg(`${index + 1}/${oddsUuids.length} Bet Processed`);
            setNotification(true);
            stackItems.push({ id: uuid, response: "success", indexing: index });
            proccessedOdds.push({ id: uuid, response: "success", indexing: index });
          } else {
            Swal.getTitle().textContent = `Wait until ${oddsUuids.length} bets will be placed...`;
            Swal.getHtmlContainer().textContent = `${index + 1}/${oddsUuids.length} Bet Processed`;
            Swal.hideLoading();
            setApiresponse("error");
            setApiResponseMsg(`${index + 1}/${oddsUuids.length} Bet Processed`);
            stackItems.push({ id: uuid, response: "error", indexing: index });
            proccessedOdds.push({ id: uuid, response: "error", indexing: index });
            setNotification(true);
          }

          if (stackItems.length > 10) {
            stackItems.shift();
          }
        }
        if (waitForSwal) {
          Swal.update({
            icon: "warning",
            confirmButtonText: "ok",
          });
          Swal.getTitle().textContent = `${oddsUuids.length} bets placed...`;
          Swal.getHtmlContainer().textContent = `${oddsUuids.length}/${
            oddsUuids.length
          } Bet Processed. 
           ${proccessedOdds.filter((si) => si.response == "success").length} Accepted, and ${
            proccessedOdds.filter((si) => si.response == "error").length
          } Rejected `;
        }
      }
    });
  }

  function showLastBets() {
    setShowBetsReport(true);
    //console.log(proccessedOdds);
  }

  const handleAutoPlaceBetsFunctionality = () => {
    if (waitForSwal) return;
    waitForSwal = Swal.fire({
      title: "Auto bet for all odds begins... ",
      html: swalBettingCounter,
      confirmButtonText: "Stop Betting proccess",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
      },
      willClose: clearSwal,
      allowOutsideClick: false,
    });
  };

  async function placeBet(oddUuid) {
    const userData = getUserData();
    let getOddsEndpoint = `/api/v1/bets/create`;
    let platformId = userData.defaultPlatform.value;
    //console.log(userData, oddUuid);
    let response = await postData(
      getOddsEndpoint,
      { currency_id: 1, amount: 1, odds: [oddUuid], platformId: platformId },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      return true;
    } else {
      return false;
    }
  }

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  function renderStackedAlerts() {
    return stackItems.map((item, index) => {
      return (
        <Snackbar
          sx={{ position: "relative !important", top: "", right: "" }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          key={"topright" + item.id + index}
          open={notification}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={`${item.response}`}
            sx={{ width: "100%" }}
            className={`api-${item.response}-notifications`}
          >
            {item.response == "success"
              ? `Bet #${item.indexing + 1}/${oddsUuids.length} has been placed!`
              : `Bet #${item.indexing + 1}/${
                  oddsUuids.length
                } not Accepted. Something goes wrong try again please!`}
          </Alert>
        </Snackbar>
      );
    });
  }

  const handleMarketsBlockedConfirmation = (e) => {
    e.preventDefault();

    Swal.fire({
      title: `Confirmation`,
      html: `You are going to save the changes you have done to Blocked Markets and Odds."</b></br> </br> Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Procceed!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setMarketsBlocked(e);
      }
    });
  };

  async function setMarketsBlocked(e) {
    e.preventDefault();
    const userData = getUserData();

    Swal.fire({
      title: "We proccess your request! ",
      html: "Wait for few seconds...",
      timerProgressBar: true,
      didOpen: async () => {
        Swal.showLoading();
        let setBlockedEndpoint = `/api/v2/panel/filters/markets/blocked`;

        let response = await postData(
          setBlockedEndpoint,
          blockedEntities.map((m) => {
            return {
              platform_id: cachedPlatform ? cachedPlatform : userData.defaultPlatform.value,
              provider_id: cachedEvent.provider_id,
              fixture_id: cachedEvent.fixtureId,
              uuid: m.uuid,
              status: m.status,
              odds: m.odds,
            };
          }),
          { Authorization: getAuthorizationHeader() },
          null,
          abortController ? { signal: abortController.signal } : null
        );

        if (!response) {
          Swal.clickDeny();
        } else {
          if (response.status === 200) {
            Swal.clickConfirm();
          }
        }
      },
      willClose: () => {},
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Request Sent!", `Blocked Markets and Odds for this Fixture sent!`, "success");
      }
      if (result.isDenied) {
        Swal.fire(
          "Error!",
          `Blocked Markets and Odds for this Fixture didnt sent! Please try again later!`,
          "error"
        );
      }
      setReleaseOperBlocked(true);
      setBlockedChanges(false);
      setBlockedEntities([]);
    });
  }

  useEffect(() => {
    if (timelineView || vlCourtView || liveStatsView) setExtraColumnView(true);
    if (!timelineView && !vlCourtView && !liveStatsView) setExtraColumnView(false);
  }, [timelineView, vlCourtView, liveStatsView]);

  useEffect(() => {
    //console.log("fixture: ", window.fixture);
    if (marketGroups) {
      if (window.fixture) {
        const userData = getUserData();
        cachedPlatform = userData.defaultPlatform.value;
        initData(window.fixture);
      } else {
      }
      cachedMarketGroups = marketGroups;
    }
  }, [marketGroups]);

  useEffect(() => {
    if (providers) {
      cachedProviders = providers;
      setOpenBackDrop(true);
      clearTimer(getDeadTime());
    }
  }, [providers]);

  useEffect(() => {
    let frameId = null;
    let settleTimerId = null;

    const updateFixtureCardHeight = () => {
      if (!fixtureCardRef.current) return;

      const cardRect = fixtureCardRef.current.getBoundingClientRect();
      const viewportHeight = window.visualViewport
        ? window.visualViewport.height
        : window.innerHeight;
      const availableHeight = Math.floor(viewportHeight - cardRect.top - 8);
      const nextHeight = Math.max(availableHeight, 330);

      setFixtureCardHeight((prev) => (prev !== nextHeight ? nextHeight : prev));
    };

    const scheduleResize = () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(updateFixtureCardHeight);
    };

    scheduleResize();
    settleTimerId = window.setTimeout(scheduleResize, 120);
    window.addEventListener("resize", scheduleResize);
    window.addEventListener("scroll", scheduleResize, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleResize);
      window.visualViewport.addEventListener("scroll", scheduleResize);
    }

    return () => {
      if (frameId) window.cancelAnimationFrame(frameId);
      if (settleTimerId) window.clearTimeout(settleTimerId);
      window.removeEventListener("resize", scheduleResize);
      window.removeEventListener("scroll", scheduleResize, true);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", scheduleResize);
        window.visualViewport.removeEventListener("scroll", scheduleResize);
      }
    };
  }, [
    notAvailable,
    notMarketsAvailable,
    markets,
    marketGroupsFiltered,
    extraColumnView,
    timelineView,
    liveStatsView,
    vlCourtView,
    scoreboardView,
  ]);

  useEffect(() => {
    return () => {
      // console.log("living page...");
      if (abortController) {
        // console.log("abortController landing page");
        abortController.abort();
      }
    };
  }, []);

  useEffect(() => {
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousBodyOverflow = document.body.style.overflow;

    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";

    return () => {
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.overflow = previousBodyOverflow;
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Stack
        spacing={1}
        direction="column"
        style={{ position: "fixed", top: "10px", right: "10px", zIndex: "10000" }}
      >
        {renderStackedAlerts()}
      </Stack>
      <Dialog
        open={showBetsReport}
        onClose={() => setShowBetsReport(false)}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">Last Bets Report</DialogTitle>
        <DialogContent dividers={true}>
          <List>
            {[...proccessedOdds].map((odd) => {
              return (
                <ListItem key={odd.id} disablePadding>
                  <span style={{ fontSize: "18px" }}>{odd.id} - </span>
                  {"   "}
                  <span
                    style={{ fontSize: "16px", color: odd.response == "error" ? "red" : "green" }}
                  >
                    {odd.response == "error" ? " (rejected)" : " (accepted)"}
                  </span>{" "}
                </ListItem>
              );
            })}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowBetsReport(false)}>ok</Button>
        </DialogActions>
      </Dialog>
      <SoftBox my={0}>
        <Card
          ref={fixtureCardRef}
          sx={{
            height: fixtureCardHeight ? `${fixtureCardHeight}px !important` : "85vh !important",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SoftBox
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            p={1}
            sx={{ height: "100%", minHeight: 0, width: "100%" }}
          >
            <Grid container sx={{ display: notAvailable ? (openBackDrop ? "none" : "") : "none" }}>
              {" "}
              <SoftTypography sx={{ textAlign: "center", width: "100%", fontSize: "1rem" }}>
                Event is not available any more.
              </SoftTypography>
            </Grid>
            <Grid container sx={{ display: openBackDrop ? "" : "none" }}>
              <div style={{ textAlign: "center", width: "100%" }}>
                <CircularProgress color="inherit" />
              </div>
            </Grid>

            <Grid sx={{ display: notAvailable ? "none" : "" }} container id={"fixture-header"}>
              <Grid
                item
                sx={{
                  position: "absolute",
                  top: "185px",
                  left: "160px",
                  scale: "40%",
                  zIndex: "10",
                  color: "#fff",
                  display: fetch ? "" : "none",
                }}
              >
                <CircularProgress fontSize="0.5rem" color="inherit" />
              </Grid>
              <OponentsView
                event={event}
                openBackDrop={fetch}
                informParent={oponentsHandleClick}
              ></OponentsView>
            </Grid>
            <Grid
              sx={{ display: notAvailable ? "none" : "" }}
              style={{ flex: 1, minHeight: 0, width: "100%", height: "100%", overflow: "hidden" }}
              container
              id="fixture-body"
            >
              <Grid container sx={{ display: notMarketsAvailable ? "" : "none" }}>
                {" "}
                <SoftTypography sx={{ textAlign: "center", width: "100%", fontSize: "1rem" }}>
                  There are no markets available at the moment.
                </SoftTypography>
              </Grid>
              <Grid
                container
                style={{
                  flex: 1,
                  minHeight: 0,
                  width: "100%",
                  overflow: "hidden",
                  flexWrap: "nowrap",
                }}
              >
                <Grid
                  id="mainColumn"
                  item
                  sm={extraColumnView ? 10 : 12}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 0,
                    height: "97%",
                    overflow: "hidden",
                  }}
                >
                  <Grid
                    container
                    id="market-groups-holder"
                    style={{ flexShrink: 0, width: "100%" }}
                    sx={{ display: notMarketsAvailable ? "none" : "" }}
                  >
                    <MarketGroupsView
                      groups={marketGroupsFiltered}
                      selectedGroup={cachedMarketGroupSelected}
                      informParent={marketGroupChange}
                      blockChanges={blockedChanges}
                    ></MarketGroupsView>
                  </Grid>
                  <Grid
                    container
                    id="markets-holder"
                    style={{
                      display: notMarketsAvailable ? "none" : "block",
                      flex: "1 1 0",
                      minHeight: 0,
                      height: "auto",
                      maxHeight: "none",
                      overflowY: "auto",
                      overflowX: "hidden",
                      paddingBottom: "26px",
                    }}
                  >
                    {markets
                      ? markets.map((m, index) => {
                          return (
                            <MarketView
                              market={m}
                              key={m.marketId + "-" + index}
                              massClose={massClose}
                              oddsStyle={oddsStyleChange}
                              informParent={blockedChange}
                              releaseOperBlocked={releaseOperBlocked}
                            ></MarketView>
                          );
                        })
                      : ""}
                  </Grid>
                </Grid>
                <Grid id="rightColumn" item sm={extraColumnView ? 2 : 0}>
                  <Card
                    sx={{
                      height: "calc(100vh - 390px) !important",
                      margin: "33px 10px",
                      backgroundColor: "#fff",
                      scrollbarWidth: "thin !important",
                      overflow: "auto !important",
                    }}
                  >
                    <SoftBox
                      display=" flex"
                      flexDirection="column"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      p={1}
                    >
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: vlCourtView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>live_tv_outlined_icon</Icon> Virtual Court
                              </SoftTypography>
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: timelineView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>format_list_bulleted_outlined_icon</Icon> Summary
                              </SoftTypography>
                            </Grid>
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              {cachedEvent && cachedEvent.live
                                ? cachedEvent.live.timeline.map((timelineEvent, i) => {
                                    return (
                                      <SoftTypography
                                        className={
                                          !timelineEvent.participant
                                            ? timelineEvent.par
                                              ? "timeline-event-" + timelineEvent.par
                                              : "timeline-event-0"
                                            : "timeline-event-" + timelineEvent.participant
                                        }
                                        key={"timelineEvent-" + i}
                                      >
                                        {timelineEvent.source
                                          ? timelineEvent.source.replace(
                                              timelineEvent.participant == 1
                                                ? cachedEvent.home
                                                : cachedEvent.away,
                                              ""
                                            )
                                          : "-"}
                                      </SoftTypography>
                                    );
                                  })
                                : ""}
                            </Grid>
                            <Grid
                              item
                              sm={12}
                              sx={{
                                top: "45px",
                                height: "calc(100% - 55px)",
                                width: "50%",
                                borderRight: "1px solid rgba(130, 125, 129, 0.62)",
                                position: "absolute",
                              }}
                            >
                              {cachedEvent && cachedEvent.live
                                ? cachedEvent.live.timeline.map((timelineEvent, i) => {
                                    return (
                                      <SoftTypography
                                        sx={{
                                          fontSize: "0.65rem",
                                          textAlign: "right",
                                          marginRight: "-5px",
                                          lineHeight: "19.5px",
                                        }}
                                        key={"timelineEvent-bullet-" + i}
                                      >
                                        <Icon
                                          sx={{
                                            fontSize: "0.65rem",
                                            color:
                                              timelineEvent.participant == 1 ||
                                              timelineEvent.par == 1
                                                ? "rgb(203, 12, 159)"
                                                : "rgba(203, 12, 159, 0.50)",
                                            cursor: "help",
                                            opacity:
                                              !timelineEvent.participant ||
                                              timelineEvent.participant == 0
                                                ? !timelineEvent.par || timelineEvent.par == 0
                                                  ? 0.3
                                                  : 1
                                                : 1,
                                          }}
                                          title={timelineEvent.source}
                                        >
                                          radio_button_checked_outlined_icon{" "}
                                        </Icon>
                                      </SoftTypography>
                                    );
                                  })
                                : ""}
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                      <Grid
                        item
                        sm={12}
                        sx={{
                          display: liveStatsView ? "" : "none",
                          width: "100%",
                          marginBottom: "10px",
                        }}
                      >
                        <Card
                          sx={{
                            height: "100% !important",
                            backgroundColor: "#e9eef2",
                          }}
                        >
                          <SoftBox
                            display=" flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            alignItems="flex-start"
                            p={1}
                          >
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              <SoftTypography
                                sx={{
                                  fontSize: "1rem",
                                  color: "#344767",
                                  paddingLeft: "5px !important",
                                  borderBottom: "1px solid #00000020",
                                  marginBottom: "10px !important",
                                }}
                              >
                                <Icon>data_saver_off_outlined_icon</Icon> Live Stats
                              </SoftTypography>
                            </Grid>
                            <Grid item sm={12} sx={{ width: "100%" }}>
                              {cachedEvent && cachedEvent.live && cachedEvent.live.scoreBoard
                                ? Object.keys(cachedEvent.live.scoreBoard).map((scItem, i) => {
                                    if (
                                      !cachedEvent.live.scoreBoard[scItem] ||
                                      !cachedEvent.live.scoreBoard[scItem].hasOwnProperty("h") ||
                                      cachedEvent.live.scoreBoard[scItem].h == -1
                                    )
                                      return "";
                                    return (
                                      <Grid
                                        container
                                        key={"scoreboard-type-" + i}
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginBottom: "5px",
                                          paddingBottom: "15px",
                                          backgroundColor: "#ffffff60",
                                        }}
                                      >
                                        <Grid item sm={12}>
                                          <SoftTypography className={"scoreboard-type"}>
                                            {scItem}
                                          </SoftTypography>
                                        </Grid>
                                        <Grid item sm={12} sx={{ display: "flex" }}>
                                          <Grid
                                            item
                                            sm={6}
                                            sx={{ paddingRight: "2px", paddingLeft: "5px" }}
                                          >
                                            <Grid item sm={12}>
                                              <SoftTypography className={"scoreboard-value"}>
                                                {cachedEvent.live.scoreBoard[scItem].h}
                                              </SoftTypography>
                                            </Grid>
                                            <Grid item sm={12} sx={{ transform: "rotate(180deg)" }}>
                                              <SoftProgress
                                                className="live-stats-bars"
                                                style={{
                                                  height: "5px",
                                                  backgroundColor: "#ffffff80",
                                                }}
                                                variant="contained"
                                                color="info"
                                                value={
                                                  cachedEvent.live.scoreBoard[scItem].h > 0
                                                    ? (100 *
                                                        cachedEvent.live.scoreBoard[scItem].h) /
                                                      (cachedEvent.live.scoreBoard[scItem].h +
                                                        cachedEvent.live.scoreBoard[scItem].g)
                                                    : 0
                                                }
                                              />
                                            </Grid>
                                          </Grid>
                                          <Grid
                                            item
                                            sm={6}
                                            sx={{ paddingLeft: "2px", paddingRight: "5px" }}
                                          >
                                            <Grid item sm={12}>
                                              <SoftTypography className={"scoreboard-value"}>
                                                {cachedEvent.live.scoreBoard[scItem].g}
                                              </SoftTypography>
                                            </Grid>
                                            <Grid item sm={12}>
                                              <SoftProgress
                                                style={{
                                                  height: "5px",
                                                  backgroundColor: "#ffffff80",
                                                }}
                                                variant="contained"
                                                color="success"
                                                value={
                                                  cachedEvent.live.scoreBoard[scItem].g > 0
                                                    ? (100 *
                                                        cachedEvent.live.scoreBoard[scItem].g) /
                                                      (cachedEvent.live.scoreBoard[scItem].h +
                                                        cachedEvent.live.scoreBoard[scItem].g)
                                                    : 0
                                                }
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    );
                                  })
                                : ""}
                            </Grid>
                          </SoftBox>
                        </Card>
                      </Grid>
                    </SoftBox>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
          </SoftBox>
        </Card>
      </SoftBox>
    </DashboardLayout>
  );
}

// Typechecking props for the DataTable
FixtureView.propTypes = {
  state: PropTypes.object,
};

export default FixtureView;
